import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth.js';
/**
 * Hook for handling authentication-related routing
 *
 * This hook automatically navigates users to appropriate pages based on their auth status:
 * - password_recovery: redirects to /reset-password
 * - Can be extended for other auth-related routing logic
 */
export const useAuthRouting = () => {
    const { status } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        switch (status) {
            case 'password_recovery':
                // User clicked password reset link, redirect to reset password page
                navigate('/reset-password', { replace: true });
                break;
            // Future: Add other auth-related routing logic here
            // case 'unauthenticated':
            //   // Could add logic for redirecting unauthenticated users
            //   break;
            default:
                // No routing action needed for other statuses
                break;
        }
    }, [status, navigate]);
};
//# sourceMappingURL=useAuthRouting.js.map